<script lang="ts" setup>
import { inject, watch, reactive } from 'vue';

import type { Ref } from 'vue';
import type { INotice } from '@/types/INotice';

const notices = inject('notices') as Ref<INotice[]>;
const noticeTimeouts = reactive(new Map<number, number>());

const dismissNotice = (noticeId: number) => {
  if (notices.value[noticeId]?.callback) {
    notices.value[noticeId].callback!();
  }

  notices.value.splice(noticeId, 1);
};

const noticesWatcher = () => {
  for (let index = 0; index < notices.value.length; ++index) {
    const notice = notices.value[index];
    const timeout = notice.timeout ?? null;

    if (timeout && !noticeTimeouts.has(index)) {
      const noticeTimeout = window.setTimeout(() => {
        dismissNotice(index);

        noticeTimeouts.delete(index);
      }, timeout);

      noticeTimeouts.set(index, noticeTimeout);
    }
  }
};

watch(notices, noticesWatcher, { deep: true });
</script>

<template>
  <div class="absolute bottom-1 right-1 flex flex-col items-end z-50">
    <div
      v-for="(notice, index) in notices"
      :key="`${index}.${notice.text}`"
      class="flex flex-row justify-between items-start w-fit max-w-[250px] mb-1 px-3 py-2.5 rounded-sm border"
      :class="`${notice.background ?? 'bg-black/75'}`"
    >
      <span class="text-xs break-words mr-1" :class="`${notice.textColor ?? 'text-white'}`">{{ notice.text }}</span>
      <span
        v-if="!notice.timeout"
        class="text-xs w-fit p-0.5 cursor-pointer rounded-sm ml-auto"
        :class="`${notice.buttonColor ?? 'bg-transparent'} ${notice.buttonText ?? 'text-black'}`"
        @click="dismissNotice(index)"
      >
        X
      </span>
    </div>
  </div>
</template>
